import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function TaskReviewersReducer(
	state = initialState.reviewAssignments,
	action
) {
	switch (action.type) {
		case types.GET_REVIEW_ASSIGNMENTS: {
			let reviewAssignments = action.response;
			return {...reviewAssignments};
		}
		case types.RESET_REVIEW_ASSIGNMENTS: {
			return null;
		}
		default:
			return state;
	}
}
